import { render, staticRenderFns } from "./ApproveListRenewContract.vue?vue&type=template&id=2fe0b4c3"
import script from "./ApproveListRenewContract.vue?vue&type=script&lang=js"
export * from "./ApproveListRenewContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports